import type { ReactNode } from "react"

import AppTopNavLayout from "@/layouts/app/app-topnav-layout"
import type { BreadcrumbItem } from "@/types"

interface AppLayoutProps {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
  topBar?: ReactNode
}

export default function AppLayout({
  children,
  breadcrumbs,
  topBar,
  ...props
}: AppLayoutProps) {
  return (
    <AppTopNavLayout breadcrumbs={breadcrumbs} topBar={topBar} {...props}>
      {children}
    </AppTopNavLayout>
  )
}
